// react-router components
// import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import RenderSocials from "bachrosenComponents/renderSocials";
// import MKButton from "components/MKButton";

function SocialsFunction() {
  return (
    <div>
      <MKTypography variant="h6" color="white" mt={8}>
        Folge uns auf
      </MKTypography>
      <Stack display="flex" direction="row" justifyContent="center" spacing={3} mt={1} mb={3}>
        <RenderSocials color="white" />
      </Stack>
    </div>
  );
}

function BachHeader({ image, title, description, isWithSocials }) {
  return (
    <MKBox
      minHeight="65vh"
      width="100%"
      sx={{
        backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
          `${linearGradient(
            rgba(gradients.dark.main, 0.6),
            rgba(gradients.dark.state, 0.6)
          )}, url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "grid",
        placeItems: "center",
      }}
    >
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={8}
          // justifyContent="flex-end"
          alignItems="center"
          flexDirection="column"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography
            variant="h1"
            color="white"
            sx={({ breakpoints, typography: { size } }) => ({
              [breakpoints.down("md")]: {
                fontSize: size["3xl"],
              },
            })}
          >
            {title}
          </MKTypography>
          <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
            {description}
          </MKTypography>
          {isWithSocials == "true" ? <SocialsFunction /> : null}
        </Grid>
      </Container>
    </MKBox>
  );
}

// Typechecking props for the CenteredBlogCard
BachHeader.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  isWithSocials: PropTypes.bool,
};

export default BachHeader;
